import { ConvexReactClient } from "convex/react";

const url = import.meta.env.VITE_CONVEX_URL;

if (!url) {
  throw new Error(
    "VITE_CONVEX_URL is not set. Copy .env.example to web/.env.local and point " +
      "it at the Convex deployment (https://lls-convex.yogourt.dev in production).",
  );
}

export const convex = new ConvexReactClient(url);
